import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { DevImpersonationService } from '../_services/dev-impersonation.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../_services/dev-impersonation.service";
var RoleGuardService = /** @class */ (function () {
    function RoleGuardService(router, roleOverrideService) {
        this.router = router;
        this.roleOverrideService = roleOverrideService;
    }
    RoleGuardService.prototype.canActivate = function (next, state) {
        var userAttr = this.roleOverrideService.getUserAttributes();
        var userRole = userAttr ? userAttr['custom:role'] : null;
        if (next.data.roles && userRole && next.data.roles.indexOf(userRole) === -1) {
            this.router.navigate(['login']);
            return false;
        }
        else {
            return true;
        }
    };
    RoleGuardService.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    RoleGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleGuardService_Factory() { return new RoleGuardService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.DevImpersonationService)); }, token: RoleGuardService, providedIn: "root" });
    return RoleGuardService;
}());
export { RoleGuardService };
